// src/data/faq.ts
export interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: 'booking' | 'services' | 'hygiene' | 'general';
}

export const faqs: FAQ[] = [
  {
    id: '1',
    question: 'How far in advance should I book an appointment?',
    answer: 'We recommend booking at least 3-5 days in advance, especially for weekends and special occasions. For bridal packages, please book at least 2 weeks in advance.',
    category: 'booking'
  },
  {
    id: '2',
    question: 'What is your cancellation policy?',
    answer: 'We require 24 hours notice for cancellations. Late cancellations (less than 24 hours) may incur a 50% fee. No-shows will be charged the full service amount.',
    category: 'booking'
  },
  {
    id: '3',
    question: 'Do you use authentic Ghanaian products?',
    answer: 'Yes, we incorporate locally-sourced ingredients like shea butter, coconut oil, neem leaves, and baobab oil in our treatments. We also use premium international brands for enhancements.',
    category: 'services'
  },
  {
    id: '4',
    question: 'How do you ensure hygiene and safety?',
    answer: 'We follow strict sterilization protocols. All tools are either single-use or autoclave sterilized. Our salon is regularly sanitized, and we use hospital-grade disinfectants.',
    category: 'hygiene'
  },
  {
    id: '5',
    question: 'Do you offer services for men?',
    answer: 'Absolutely. We provide professional grooming services for men including manicures, pedicures, and nail treatments tailored for male clients.',
    category: 'services'
  },
  {
    id: '6',
    question: 'Can you accommodate group bookings?',
    answer: 'Yes, we offer group packages for bridal parties, corporate events, and special occasions. Please contact us directly for groups of 4 or more people.',
    category: 'booking'
  },
  {
    id: '7',
    question: 'What payment methods do you accept?',
    answer: 'We accept cash, mobile money (MTN & Vodafone), Visa/Mastercard, and bank transfers. Payment is required at the time of service.',
    category: 'general'
  },
  {
    id: '8',
    question: 'Do you offer mobile services?',
    answer: 'Yes, we provide mobile nail services for corporate events, weddings, and private parties in the Greater Accra region. Additional travel fees apply based on location.',
    category: 'services'
  }
];